import { CircularProgress as MuiCircularProgress, type CircularProgressProps as MuiCircularProgressProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

const SIZE_IN_PIXELS = { small: 16, medium: 24, large: 40 } as const;

type Props = WithoutStyleOverrides<Omit<MuiCircularProgressProps, 'size'>> & {
  size?: keyof typeof SIZE_IN_PIXELS;
};

export function CircularProgress(props: Props) {
  const { size = 'medium', ...circularProgressProps } = props;

  return <MuiCircularProgress {...circularProgressProps} size={SIZE_IN_PIXELS[size]} />;
}

export type { Props as CircularProgressProps };
